import { quoteEditModeCompatibleRoutesSlugs } from '~/components/quote/consts';
import { useUiStore } from '~/stores';

export default defineNuxtRouteMiddleware((to) => {
  const { showQuoteOverlay, toggleQuoteOverlay } = useUiStore();
  if (!showQuoteOverlay) return;

  const isNextRouteValidForQuotes = quoteEditModeCompatibleRoutesSlugs.some((route) => to.path.includes(route));
  if (!isNextRouteValidForQuotes) toggleQuoteOverlay(false);
});
